import { OpenTelemetryManager } from '@measurement/opentelemetry-web';
import apiConfig from './apiConfig';

const otelConfig = {
  apiKey: apiConfig.otelKey,
  serviceName: 'polaris',
  environment: apiConfig.telemetryEnv,
};

export const initTelemetry = () => {
  if (process.env.NODE_ENV === 'test') return;
  OpenTelemetryManager.initialize(otelConfig);
};
